<mat-card class="invoice-container mat-elevation-z8">
    <div class="container">
        <div class="top-info">
          <div class="left-side">
            <div class="logo">
              <img *ngIf="showInvoiceHeader && topLevelUser?.company_logo" src="{{topLevelUser?.company_logo}}" alt="logo">
            </div>
            <br>
            <br>
            <br>
            <br>
            <div class="bill-to">
              <div class="title-header">
                <span class="bill-text">BILL TO</span>
              </div>
    
              <div class="content">
                <h2>{{ orderUserData?.company }}</h2>
                <span>{{ orderUserData?.address }}</span>
                <span>Tel: {{ orderUserData?.phone }}</span>
                <span>Email: {{ orderUserData?.email }}</span>
                <span>VAT/ TAX ID # {{ orderUserData?.vat_tax_id }}</span>
              </div>
            </div>
          </div>
          <div class="right-side">
            <div class="invoice-detail">
              <h3>INVOICE # <span> {{ orderDetails?.invoice_code }}</span></h3>
              <table>
                <tr class="th">
                  <th>DATE</th>
                  <th>DUE DATE</th>
    
                </tr>
                <tr>
                  <td> {{ orderDetails?.created_time | date: 'MM/dd/yyyy' }}</td>
                  <td> {{ orderDetails?.created_time | date: 'MM/dd/yyyy' }}</td>
                </tr>
                <tr>
                  <td><span *ngIf="getLocalTimezone() != 'America/Los_Angeles' && orderDetails">LOCAL TIME ZONE</span>
                  </td>
                  <td>TOTAL DUE</td>
                </tr>
                <tr>
                  <td> <span *ngIf="getLocalTimezone() != 'America/Los_Angeles' && orderDetails">{{ getLocalTimezone()
                      }}</span></td>
                  <td>{{ orderDetails?.accessory_product_detail?.currency_detail?.symbol }}{{ orderDetails?.unit_price * orderDetails?.item_count | number }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
    
      </div>
      <table class="simple invoice-table" id="invoice-table">
        <thead>
            <tr>
                <th *ngFor="let title of titles">{{title}}</th>
                <!-- <th></th> -->
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <!-- <td>
            {{invoice.buyer.company}}
          </td> -->
                <td>
                    <span>
                        {{orderDetails?.accessory_product_detail?.name}} - {{orderDetails?.accessory_product_detail?.currency_detail?.symbol}}{{
                        orderDetails?.accessory_product_detail?.unit_price |
                        number }}
                    </span>
                </td>
                <td>
                    {{orderDetails.item_count}}
                </td>
                <td>
                    {{ orderDetails?.accessory_product_detail?.currency_detail?.symbol }}{{ orderDetails?.unit_price }}

                </td>
                <td>
                    {{ orderDetails?.accessory_product_detail?.currency_detail?.symbol }}{{ orderDetails?.unit_price * orderDetails?.item_count | number }}
                </td>
            </tr>
        </tbody>
      </table>
    
      <div class="flex-end" id="total">
        <table class="simple invoice-table-footer">
          <tbody>
            <tr class="subtotal">
                <td>SUBTOTAL</td>
                <td>{{ orderDetails?.accessory_product_detail?.currency_detail?.symbol }}{{ orderDetails?.unit_price * orderDetails?.item_count | number }}</td>
            </tr>
            <tr class="total">
                <td>TOTAL</td>
                <td>{{ orderDetails?.accessory_product_detail?.currency_detail?.symbol }}{{ orderDetails?.unit_price * orderDetails?.item_count | number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    
      <div class="print-page" #printPage>
        <div class="fixed-image-container">
          <img src="/assets/images/bg-pattern.png">
          <div class="wrapper overlay-text" *ngIf="showInvoiceHeader">
            <div><span class="title-badge">COMPANY</span><span>{{ topLevelUser?.company }}</span></div>
            <div><span class="title-badge">ADDRESS</span><span>{{ topLevelUser?.address }}</span></div>
            <div><span class="title-badge">EMAIL</span><span>{{ topLevelUser?.email }}</span></div>
            <div><span class="title-badge">PHONE</span><span>{{ topLevelUser?.phone }}</span></div>
          </div>
        </div>
      </div>
</mat-card>